import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { CTAButton } from "@/components/CTAButton";
import { MENU, BUSINESS } from "@/data/site";

function Tag({ children }) {
  return (
    <span className="ml-3 align-middle rounded-full border border-brand-gold/50 bg-brand-gold/10 px-2.5 py-0.5 text-[10px] uppercase tracking-[0.12em] text-brand-ink/70">
      {children}
    </span>
  );
}

export default function MenuPage() {
  return (
    <>
      <SEO title="Menu" description="Explore the Chopstick Chinese Corner menu — dim sum, hand-pulled noodles, wok classics, sides and sweets. Sector xxx, Gurugram." />
      <PageHero
        overline="The menu"
        titleLines={["Dim sum to", "wok classics."]}
        subtitle="A tight, considered menu of the dishes we love most. Prices are placeholders — please call to confirm current pricing and daily specials."
      />

      <section className="mx-auto max-w-5xl px-5 md:px-8 py-20 md:py-28">
        <div className="space-y-20 md:space-y-28">
          {MENU.map((section) => (
            <div key={section.category} data-testid={`menu-section-${section.category}`}>
              <Reveal>
                <h2 className="font-display text-3xl md:text-5xl text-brand-ink border-b border-brand-ink/15 pb-5">
                  {section.category}
                </h2>
              </Reveal>
              <Stagger className="mt-8 grid gap-x-12 gap-y-8 md:grid-cols-2">
                {section.items.map((item, i) => (
                  <StaggerItem key={i}>
                    <div className="group flex items-start gap-4 border-b border-dashed border-brand-ink/15 pb-4">
                      {item.image && (
                        <div className="h-16 w-16 md:h-20 md:w-20 shrink-0 overflow-hidden rounded-md bg-brand-ink/5">
                          <img
                            src={item.image}
                            alt={item.name}
                            loading="lazy"
                            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
                          />
                        </div>
                      )}
                      <div className="min-w-0 flex-1">
                        <div className="flex items-baseline gap-3">
                          <h3 className="font-display text-xl text-brand-ink">
                            {item.name}
                            {item.tag && <Tag>{item.tag}</Tag>}
                          </h3>
                          <span className="flex-1 border-b border-dotted border-brand-ink/20 translate-y-[-4px]" aria-hidden="true" />
                          <span className="font-medium text-brand-red whitespace-nowrap">{item.price}</span>
                        </div>
                        <p className="mt-1 text-sm text-muted-foreground leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                  </StaggerItem>
                ))}
              </Stagger>
            </div>
          ))}
        </div>

        <Reveal>
          <div className="mt-20 border border-brand-ink/12 bg-white p-8 md:p-10 text-center">
            <h3 className="font-display text-2xl md:text-3xl text-brand-ink">Prefer to order in?</h3>
            <p className="mt-3 text-muted-foreground">Get Chopstick delivered via our partners, or call us for takeaway.</p>
            <div className="mt-6 flex flex-wrap justify-center gap-3">
              <CTAButton href={BUSINESS.zomatoUrl} variant="primary" target="_blank" rel="noopener noreferrer" data-testid="order-zomato">Order on Zomato</CTAButton>
              <CTAButton href={BUSINESS.swiggyUrl} variant="dark" target="_blank" rel="noopener noreferrer" data-testid="order-swiggy">Order on Swiggy</CTAButton>
              <CTAButton href={`tel:${BUSINESS.phoneHref}`} variant="ghost" icon={false}>Call for takeaway</CTAButton>
            </div>
          </div>
        </Reveal>
      </section>
    </>
  );
}
